import React, { useEffect, useRef } from "react";
import { Container } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import {
  ContainerButton,
  Input,
  TextTitle,
  Title,
} from "../../../../../styles/global";
import Panel from "../../../../../components/Panel";
import { FormHandles } from "@unform/core";
import { Form } from "@unform/web";
import { Link, useParams } from "react-router-dom";
import useOrigemDemanda from "../../../../../actions/cruds/Protocolo/useOrigemDemanda";
// import { Container } from './styles';

const OrigemDemandaView: React.FC = () => {
  const { origemId } = useParams();
  const { origemDemanda, getOrigemDemanda } = useOrigemDemanda();

  const formRef = useRef<FormHandles>(null);

  useEffect(() => {
    getOrigemDemanda(origemId);
  }, []);

  return (
    <Container>
      <Title>
        <span>Visualizar Origem da Demanda</span>
      </Title>

      <Form id="form1" ref={formRef}>
        <Panel titulo="Origem da Demanda">
          <Grid container spacing={6}>
            <Grid xs={12}>
              <TextTitle>Nome:</TextTitle>
              <Input type="text" name="nome" value={origemDemanda.nome} disabled />
            </Grid>
          </Grid>
        </Panel>
        <ContainerButton>
          <Link to="/protocolo/cadastros/origem_demanda">
            <button>Voltar</button>
          </Link>
        </ContainerButton>
      </Form>
    </Container>
  );
};

export default OrigemDemandaView;
